/**
 * @generated SignedSource<<03ef84f715f8ae70b74bbe434292efdd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type announcement_periscope_CompassAnnouncementTask$data = {
  readonly __typename: "WorkSuggestionsCompassAnnouncementTask";
  readonly componentName: string | null | undefined;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly senderComponentName: string | null | undefined;
  readonly targetDate: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "announcement_periscope_CompassAnnouncementTask";
};
export type announcement_periscope_CompassAnnouncementTask$key = {
  readonly " $data"?: announcement_periscope_CompassAnnouncementTask$data;
  readonly " $fragmentSpreads": FragmentRefs<"announcement_periscope_CompassAnnouncementTask">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "announcement_periscope_CompassAnnouncementTask",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "componentName"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "senderComponentName"
    },
    {
      "kind": "ScalarField",
      "name": "targetDate"
    }
  ],
  "type": "WorkSuggestionsCompassAnnouncementTask"
};

(node as any).hash = "c96373a29af19db5215070530db5d093";

export default node;
